// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__-0W38","spacer":"Projects_spacer__ucWBQ","projectContainer":"Projects_projectContainer__d6BXR"};